module.exports = __webpack_public_path__ + "img/modal-document-create-success.2a59bed9.svg";